import React from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  TextField,
  List,
  ListItem,
  ListItemText,
  Divider,
  FormControl,
  InputAdornment,
} from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import SearchIcon from "@material-ui/icons/Search";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const AttendancePreview = ({ primaryText, secondaryText }) => {
  const [selectedDate, setSelectedDate] = React.useState("March 19th, 2025");

  const attendanceGroups = [
    { name: "GroupSunday", count: 1 },
    { name: "Volunteer Group", count: 12 },
    { name: "Unity Service", count: 20 },
    { name: "All members", count: 1251 },
  ];

  const WhiteChevronIcon = (props) => (
    <ExpandMoreIcon {...props} style={{ color: "white" }} />
  );

  return (
    <Box sx={{ backgroundColor: "#fff" }} className="disabled-container">
      <Box
        sx={{
          p: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fff",
        }}
      >
        <FormControl
          style={{
            width: "175px",
            margin: 0,
            padding: 0,
            minWidth: 0,
          }}
        >
          <Select
            labelId="date-label"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            displayEmpty
            IconComponent={WhiteChevronIcon}
            variant="outlined"
            style={{
              backgroundColor: "#1976d2",
              color: "white",
              borderRadius: 4,
              fontSize: "14px",
              padding: "2px 8px",
              height: 32,
              minHeight: "unset",
            }}
            inputProps={{
              style: {
                padding: "4px 8px",
                height: 32,
              },
            }}
          >
            <MenuItem value="March 19th, 2025" style={{ fontSize: "0.75rem" }}>
              March 19th, 2025
            </MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Box>
        <Box sx={{ pl: 2, pb: 0 }}>
          <Typography
            sx={{ color: `${secondaryText} !important` }}
            variant="subtitle2"
            gutterBottom
          >
            Select a group
          </Typography>
        </Box>

        <Box sx={{ backgroundColor: "#F6F6F6", pl: 1, pt: 1, pb: 1, pr: 1 }}>
          <TextField
            className="input-field"
            placeholder="Search"
            variant="outlined"
            fullWidth
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ fontSize: 18, pb: "2px" }} />
                </InputAdornment>
              ),
              sx: {
                height: 28,
              },
            }}
          />
        </Box>
        <List disablePadding>
          {attendanceGroups.map((group, index) => (
            <React.Fragment key={group.name}>
              <ListItem
                secondaryAction={<ChevronRightIcon fontSize="small" />}
                button
                sx={{ py: 1.5 }}
              >
                <ListItemText
                  primary={group.name}
                  primaryTypographyProps={{ fontWeight: "medium" }}
                  sx={{ color: primaryText }}
                />
                <Typography color={primaryText}>{group.count}</Typography>
              </ListItem>
              {index < attendanceGroups.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default AttendancePreview;
